<template>
    <jet-dialog-modal :show="horse" @close="$emit('close')">
        <template #title>
            Pferd bearbeiten
        </template>
        <template #content>
            <div class="grid md:grid-cols-2 grid-cols-1 gap-4">
                <div v-for="input in input_editable">
                    <label :for="input.toLowerCase()" class="block text-sm font-medium text-gray-700">{{ input }}</label>
                    <div class="mt-1">
                        <input type="text" :name="input.toLowerCase()" :id="input.toLowerCase()" class="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm rounded-md" :class="form.errors[input.toLowerCase()] ? 'border-red-300 text-red-900' : 'border-gray-300'" :placeholder="input" v-model="form[input.toLowerCase()]">
                    </div>
                </div>
            </div>

            <div class="w-full mt-5">
            <span class="grid md:grid-cols-3 gap-4">
                <button class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                  Stall ändern
                </button>
                <button class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-secondary-600 hover:bg-secondary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-500">
                  Stall ansehen
                </button>
                <button class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-tertiary-600 hover:bg-tertiary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tertiary-500">
                  Zubuchoptionen bearbeiten
                </button>
            </span>
            </div>
            <div class="mt-5">
                <div class="sm:hidden">
                    <label for="tabs" class="sr-only">Select a tab</label>
                    <select id="tabs" name="tabs" v-model="active_tab" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
                        <option value="0">Ställe</option>
                        <option value="1">Einzelbuchungen</option>
                        <option value="2">Einzelbuchung hinzufügen</option>
                        <option value="3">Wiederkehrende Buchungen</option>
                    </select>
                </div>
                <div class="hidden sm:block">
                    <nav class="flex space-x-4" aria-label="Tabs">
                        <button @click="active_tab = 0" class="px-3 py-2 font-medium text-sm rounded-md" :class="active_tab == 0 ? 'bg-primary-100 text-primary-700' : 'text-gray-500 hover:text-gray-700'">
                            Ställe
                        </button>
                        <button @click="active_tab = 1" class="px-3 py-2 font-medium text-sm rounded-md" :class="active_tab == 1 ? 'bg-primary-100 text-primary-700' : 'text-gray-500 hover:text-gray-700'">
                            Einzelbuchungen
                        </button>
                        <button @click="active_tab = 2" class="px-3 py-2 font-medium text-sm rounded-md" :class="active_tab == 2 ? 'bg-primary-100 text-primary-700' : 'text-gray-500 hover:text-gray-700'">
                            Einzelbuchung hinzufügen
                        </button>
                        <button @click="active_tab = 3" class="px-3 py-2 font-medium text-sm rounded-md" :class="active_tab == 3 ? 'bg-primary-100 text-primary-700' : 'text-gray-500 hover:text-gray-700'">
                            Wiederkehrende Buchungen
                        </button>
                    </nav>
                </div>
            </div>
            <div class="mt-5" v-if="active_tab == 0">
                <div class="flow-root">
                    <ul class="-mb-8" v-if="horse.stable">
                        <li v-for="(price, i) in horse.price_history_stable">
                            <div class="relative pb-8">
                                <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" v-if="i+1 < horse.price_history_stable.length"></span>
                                <div class="relative flex space-x-3">
                                    <div>
                                        <span class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white" :class="price.in_effect_till ? 'bg-red-400' : 'bg-green-400'">
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-if="price.in_effect_till">
                                              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z" clip-rule="evenodd" />
                                            </svg>
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-else>
                                              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                                            </svg>
                                        </span>
                                    </div>
                                    <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                                        <div>
                                            <p class="text-sm text-gray-500">{{ price.name }} ({{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price.value) }} mit {{ price.vat }}% Ust)</p>
                                        </div>
                                        <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                            {{ !price.in_effect_till ? 'seit ' : '' }}
                                            {{ new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(price.in_effect_from)) }}
                                            {{ price.in_effect_till ? '-'+new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(price.in_effect_till)) : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mt-5" v-if="active_tab == 1">
                <div class="flow-root">
                    <ul class="-mb-8" v-if="horse.stable">
                        <li v-for="(price, i) in horse.price_history">
                            <div class="relative pb-8">
                                <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" v-if="i+1 < horse.price_history.length"></span>
                                <div class="relative flex space-x-3">
                                    <div>
                                        <span class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white" :class="price.pivot.export_id ? 'bg-yellow-400' : price.pivot.subscription_id ? 'bg-secondary-400' : 'bg-primary-400'">
                                            <!-- "Normal" -->
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-if="!price.pivot.subscription_id && !price.pivot.export_id">
                                              <path d="M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z" />
                                            </svg>
                                            <!-- "Exported" -->
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-else-if="price.pivot.export_id">
                                              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z" clip-rule="evenodd" />
                                            </svg>
                                            <!-- "Recurring" -->
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-else>
                                              <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </div>
                                    <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                                        <div>
                                            <p class="text-sm text-gray-500">{{ price.name }} ({{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price.pivot.value) }} mit {{ price.pivot.vat }}% Ust{{ price.pivot.export_id ? ', abgerechnet' : '' }})</p>
                                        </div>
                                        <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                            {{ new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(price.pivot.date)) }}
                                            <p class="font-medium text-blue-600 hover:text-blue-500 cursor-pointer" @click="deleteNext = time.id" v-if="!price.pivot.export_id">Löschen</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="active_tab == 2" class="grid-cols-1 md:grid-cols-2 grid gap-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700">Preis</label>
                    <div class="mt-1">
                        <multiselect :options="prices.map(x => {return {type: x.type, value: x.id, label: `${x.name} (${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(x.value)})`}}).filter(x => {return x.type != 'stable'})" v-model="order.price" noOptionsText="Es sind keine Preise hinterlegt" noResultsText="Es wurden keine Preise gefunden" />
                        <p class="mt-2 text-sm text-red-600" v-if="order.errors.price">{{ order.errors.price }}</p>
                    </div>
                </div>
                <div>
                    <label for="date" class="block text-sm font-medium text-gray-700">Datum</label>
                    <div class="mt-1">
                        <input type="date" name="date" id="date" v-model="order.date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-md" :class="order.errors.date ? 'border-red-300 text-red-900' : 'border-gray-300'" placeholder="2020-01-01">
                    </div>
                </div>
                <button @click="order.horse = horse.id; order.post(route('horses.book'), {onSuccess: () => {active_tab = 1; $emit('refresh')}});" class="col-span-full inline-flex items-center px-4 py-2 bg-primary-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-primary-700 active:bg-primary-900 focus:outline-none focus:border-primary-900 focus:shadow-outline-primary transition ease-in-out duration-150">
                    Hinzufügen
                </button>
            </div>
            <div class="mt-5" v-if="active_tab == 3">
                <div class="flow-root">
                    <ul class="-mb-8" v-if="horse.stable">
                        <li v-for="(subscription, i) in horse.subscriptions">
                            <div class="relative pb-8">
                                <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" v-if="i+1 < horse.subscriptions.length"></span>
                                <div class="relative flex space-x-3">
                                    <div>
                                        <span class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white" :class="subscription.cancelled_date ? new Date(subscription.cancelled_date) >= new Date() ? 'bg-primary-400' : 'bg-yellow-400' : 'bg-secondary-400'">
                                            <!-- "cancelled" -->
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-if="subscription.cancelled_date && new Date(subscription.cancelled_date) < new Date()">
                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                                            </svg>
                                            <!-- "Normal" -->
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-else-if="subscription.cancelled_date">
                                              <path d="M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z" />
                                            </svg>
                                            <!-- "Recurring" -->
                                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" v-else>
                                              <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </div>
                                    <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                                        <div>
                                            <p class="text-sm text-gray-500">{{ subscription.price_info.name }} zum {{ subscription.recurring_date }}. ({{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(subscription.price_info.value) }} mit {{ subscription.price_info.vat }}% Ust)</p>
                                        </div>
                                        <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                            {{ !subscription.cancelled_date ? 'seit' : '' }}
                                            {{ new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(subscription.created_at)) }}
                                            {{ subscription.cancelled_date ? '-'+new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(subscription.cancelled_date)) : '' }}
                                            <p class="font-medium text-blue-600 hover:text-blue-500 cursor-pointer" @click="deleteNext = time.id" v-if="!subscription">Löschen</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template #footer>
            <button @click="$emit('close')" class="inline-flex items-center px-4 py-2 bg-primary-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-primary-700 active:bg-primary-900 focus:outline-none focus:border-primary-900 focus:shadow-outline-primary transition ease-in-out duration-150 mr-2">
                Abbrechen
            </button>
            <button @click="edit" class="inline-flex items-center px-4 py-2 bg-primary-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-primary-700 active:bg-primary-900 focus:outline-none focus:border-primary-900 focus:shadow-outline-primary transition ease-in-out duration-150">
                Speichern
            </button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import JetDialogModal from "@/Jetstream/DialogModal"
import Multiselect from '@vueform/multiselect'
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";

export default {
    emits: ['close'],
    name: "HorseEdit",
    props: ['horse', 'prices'],
    components: {
        Label,
        Button,
        JetDialogModal,
        Multiselect
    },
    data: function () {
        return {
            form: this.$inertia.form({
                name: this.horse.name,
                besitzer: this.horse.besitzer,
                kdnr: this.horse.kdnr,
            }),
            order: this.$inertia.form({
                price: null,
                horse: this.horse.id,
                date: new Date().toISOString().split('T')[0]
            }),
            input_editable: ['Name', 'Besitzer', 'Kdnr'],
            active_tab: 0
        }
    }
}
</script>


<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>

</style>
